import { render } from "./HighlightsDetail.vue?vue&type=template&id=5213ec99&scoped=true"
import script from "./HighlightsDetail.vue?vue&type=script&lang=js"
export * from "./HighlightsDetail.vue?vue&type=script&lang=js"

import "./HighlightsDetail.vue?vue&type=style&index=0&id=5213ec99&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5213ec99"]])

export default __exports__